import request from '@/api/request.js'

const dictionaryApi = {}

/**
 * 查询辞书列表
 */
dictionaryApi.queryDicList = param => {
  return request({
    url: '/function/dictionary/list',
    method: 'GET',
    params: param
  })
}

/**
 * 新增辞书
 */
dictionaryApi.addDicBook = param => {
  return request({
    url: '/function/dictionary',
    method: 'POST',
    data: param
  })
}
/**
 * 编辑图书
 */
dictionaryApi.upDateDicBook = param => {
  return request({
    url: '/function/dictionary',
    method: 'PUT',
    data: param
  })
}
/**
 * 根据ID查询详情
 */
dictionaryApi.queryDetailByID = param => {
  return request({
    url: '/function/dictionary',
    method: 'GET',
    params: param
  })
}
/**
 * 删除辞书
 */
dictionaryApi.deleteDictByIds = param => {
  return request({
    url: '/function/dictionary/remove',
    method: 'POST',
    data: param
  })
}

/**
 * 置顶一本图书
 */
dictionaryApi.setTopOne = param => {
  return request({
    url: '/function/dictionary/setTopOne',
    method: 'GET',
    params: param
  })
}

// 上传接口
dictionaryApi.upLoadData = param => {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: param
  })
}
export default dictionaryApi
